import React, { memo } from 'react';
import Dropdown from '@components/@core/Dropdown';
import { COMPANY_FEATURES, FEATURE_OPTIONS } from '~/services/constants';

const CompanyFeatures = ({ data = {}, onFeatures = () => {} }) => {
    return (
        <div className="card mb-3 vdra-features">
            <p className="dsl-b22 bold">Select Features</p>

            {COMPANY_FEATURES.map((feature) => {
                const disabled = feature.id === 'hcm' || feature.id === 'store' ? ['enable'] : [];
                return (
                    <div key={feature.id} className="d-flex ai-center">
                        <Dropdown
                            title={feature.label}
                            align="right"
                            width="fit-content"
                            defaultIds={[data[feature.id]]}
                            disabledOptions={disabled}
                            data={FEATURE_OPTIONS}
                            getId={(e) => e.value}
                            getValue={(e) => e.label}
                            onSelected={(e) => onFeatures(feature.id, e)}
                        />
                    </div>
                );
            })}
        </div>
    );
};

export default memo(CompanyFeatures);
